import { BaseModel, attr, belongsTo } from "../../lib/itn-ui-kit/data";

export default class ProviderClientStatusModel extends BaseModel {
    static urlPath = 'pro_cli_status';

    @attr('datetime') createdAt;
    @attr('daterime') updateAt;
    @attr('string') createdBy;
    @attr('string') updatedBy;
    @attr('string') createdByName;
    @attr('string') updatedByName;
    @belongsTo('client') client;
    @belongsTo('provider') provider;
    @belongsTo('case') case;
    @attr('number') medicalDocumentsStatus;
    @attr('boolean') finishedTreatment;
    @attr('boolean') canEdit;
    @attr('datetime') firstAppointmentDate;
    @attr('number') currentBalance;
    @attr('string') medicalRecordNumber;
    @attr('boolean') canViewBalanceAndMrn;
    @attr('boolean') canEditBalanceAndMrn;
    @attr('number') estimatedAppointmentCount;
    @attr('string') confirmedBalance;
    @attr('string') runningTotal;
    @attr('number') apptNoBillCount;
    @attr('number') scheduledApptCount;
    @attr('datetime') treatmentStatusChanged;
    @attr('datetime') documentStatusChanged;
    @attr('string') treatmentStatusChangedByName;
    @attr('string') documentStatusChangedByName;
    @attr('number') completedApptCount;
    @attr('number') completionPercentage;
    @attr('datetime') lastAppointmentDate;
    @attr('string') confirmedBalanceChanged;
    @attr('string') runningTotalChanged;
    @attr('number') missedApptCount;
    @attr('number') totalDaysInTreatment;
    @attr('string') confirmedBalanceChangedByName;
    @attr('string') runningTotalChangedByName;

    get totalCount() {
        return this.actions.POST.count;
      }
}